var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 12,
    viewBox: "0 0 12 12",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.95641 1c-.18534 0-.35117.11262-.42034.28377-.07005.17115-.02837.36713.10376.49571l4.21932 4.21933-4.21932 4.21929c-.11883.1135-.16672.2829-.12504.4425.04168.1588.16583.2829.32456.3246.15963.0417.329-.0062.44251-.125l4.54034-4.54037c.17736-.17736.17736-.46468 0-.64203l-4.54034-4.54035c-.08602-.08779-.20307-.13745-.32545-.13745z",
    fill: "#697586"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.9667d1fe11a87748db1c765e01b6d1c6.svg";
export { ForwardRef as ReactComponent };